var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MobileLayout',[_c('div',{staticClass:"mobile-header"},[_c('span'),_c('span',{staticClass:"header-title"},[_vm._v("Trainer Chat")]),_c('span')]),_c('ChatList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }